import Cookies from "js-cookie";
import {
  getWebSocketInstance
} from "@/utils/websocketManager";
import configs from "@utils/vue-axios.config";

const state = {
  socket: null, // WebSocket instance
  listeners: new Map(), // Store event listeners
  isConnected: false, // Track connection status
};

const mutations = {
  SET_SOCKET(state, socket) {
    state.socket = socket;
  },
  SET_CONNECTED(state, status) {
    state.isConnected = status;
  },
};

const actions = {
  connect({
    commit,
    state
  }) {
    const accessToken = Cookies.get("Admin-Token");

    // Avoid reconnecting if the socket is already open
    if (state.socket && state.socket.readyState !== WebSocket.CLOSED) {
      return;
    }

    // Establish connection using the global WebSocket manager
    const socket = getWebSocketInstance(configs.WS_URL, accessToken);
    commit("SET_SOCKET", socket);

    // Listen for the "open" event to confirm the connection
    socket.addEventListener("open", () => {
      commit("SET_CONNECTED", true);
      console.log("WebSocket connected");
      actions.setEventListener({
        commit,
        state
      });
    });

    // Listen for errors and closure events
    socket.addEventListener("error", (error) => {
      console.error("WebSocket error:", error);
    });

    socket.addEventListener("close", () => {
      commit("SET_CONNECTED", false);
      console.log("WebSocket closed");
    });

    // Start ping-pong logic
    actions.startPingPong({
      state
    });
  },

  setEventListener({
    state
  }) {
    // Set up event listener for incoming messages
    state.socket.addEventListener("message", actions.handleMessage);
  },

  handleMessage(event) {
    if (!event.data) return

    const data = JSON.parse(event.data);
    console.log("Received message:", data);

    // Handle the ping-pong response
    if (data.action === "pong") return

    // Notify listeners about the message
    state.listeners.forEach((callback) => callback(data));
  },

  addListener({
    state
  }, {
    label,
    callback
  }) {
    if (typeof callback === "function") {
      state.listeners.set(label, callback);
    }
  },

  sendRequest({
    state
  }, {
    action,
    requestId,
    query
  }) {
    if (state.socket && state.socket.readyState === WebSocket.OPEN) {
      const request = {
        action,
        request_id: requestId,
        query,
      };
      state.socket.send(JSON.stringify(request));
      console.log("Request sent:", request);
    } else {
      console.error("Socket not connected, request not sent");
    }
  },

  startPingPong({
    state
  }) {
    state.pingInterval = setInterval(() => {
      if (state.socket && state.socket.readyState === WebSocket.OPEN) {
        console.log("Sending ping...");
        state.socket.send(JSON.stringify({
          action: "ping"
        }));
      }
    }, 3000);
  },

  // Optional method to stop ping-pong when not needed
  stopPingPong({
    state
  }) {
    if (state.pingInterval) {
      clearInterval(state.pingInterval);
    }
  },
};

const getters = {
  socket: (state) => state.socket,
  isConnected: (state) => state.isConnected,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
